import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { NiveauQualification } from 'src/app/shared/models/niveauQualification';

@Component({
	selector: 'app-niveauQualification-modal-ajout',
	templateUrl: './niveauQualification-modal-ajout.component.html',
	styleUrls: ['./niveauQualification-modal-ajout.component.scss']
})
export class NiveauQualificationModalAjoutComponent {
	NAME_PATTERN = '^[^0-9]+$';

	formEdit = new FormGroup({
		name: new FormControl('', [
			Validators.required
		])
	});

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private logger: LogService
	) {}

	// ngOnInit(): void {}

	onSubmit() {
		this.isValidateButtonClicked = true;
		const niveauQualification = new NiveauQualification();
		niveauQualification.name = this.formEdit.get('name').value;
		this.facade.niveauQualificationService.addNiveauQualification(niveauQualification).subscribe({
			next: (succ) => {
				this.bsModalRef.hide();
				// this.isValidateButtonClicked=false;
			},
			error: (err) => {
				this.isValidateButtonClicked = false;
				this.facade.toastService.createHttpErrorToast(
					err.error.message ? err.error.message : '',
					err.status
				);
				this.logger.error(err);
			}
		});
	}

	get name() {
		return this.formEdit.get('name');
	}
}
